import { Badge } from '../ui/badge';
import { cn } from '../../lib/utils';
import { getCategoryColor, ON_CATEGORY_COLOR } from '../../utils/categoryColors';

/**
 * An equipment category as a small tag: the category's fill with the
 * on-category text colour. The one place a category badge is drawn.
 */
export function CategoryBadge({ category, className, ...props }) {
  return (
    <Badge
      variant="secondary"
      className={cn('rounded-small border-transparent font-normal', className)}
      style={{ backgroundColor: getCategoryColor(category), color: ON_CATEGORY_COLOR }}
      {...props}
    >
      {category}
    </Badge>
  );
}
